import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ConfirmActionModalComponent } from '../confirm-action-modal/confirm-action-modal.component';
import { FamilyMoveFlowController } from '../../utils/family-move.controller';

/**
 * "Move to own number" pop-up of the Family Plan tab (CWS-1579, CWS-1582 §7). Presentational: the
 * flow controller owns the number, the lookup and the request; this renders it.
 * Steps: the member's number → confirm (the plate keeps billing the primary's card).
 *
 * @selector app-family-move-modal
 * @input flow - The move flow of the host tab.
 */
@Component({
  selector: 'app-family-move-modal',
  standalone: true,
  imports: [FormsModule, ConfirmActionModalComponent],
  templateUrl: './family-move-modal.component.html',
  styleUrls: ['./family-move-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class FamilyMoveModalComponent {
  @Input({ required: true }) flow!: FamilyMoveFlowController;

  get plate(): string {
    return this.flow.member?.vehicle.license_plate ?? 'this plate';
  }
}
